const enJSON = {
  imagePrediction_one: '{{count}} image with this prediction',
  imagePrediction_other: '{{count}} images with this prediction',
  showingTypeTotal: 'Total: {{total}} {{type}}',
  decisionHeatMap: 'Decisions over last {{period}} days {{locationName}}',
  periodInDays: '{{days}} days'
};

export default enJSON;
